import { defineStore } from 'pinia'

type State = {
  title: string,
}

export const APP_TITLE: string = import.meta.env.VITE_APP_TITLE ?? ''

export const usePageStore = defineStore('Page', {
  state: (): State => ({
    title: '',
  }),
  actions: {
    setPageTitle (title: string) {
      this.title = title
      document.title = `${title} | ${APP_TITLE}`
    },
  },
})
